/**
 * Décision d'accès au Master Shell — fonction PURE (testable sans rendu).
 *
 * P0 frontière plateforme, sous-lot F (2026-07-23). L'autorité plateforme est
 * établie EXCLUSIVEMENT par une affectation canonique active dans
 * `rectorium_team_members` (lue côté serveur sous RLS `platform_admin_only`,
 * durcie par C2), avec un `master_portal_role` dans l'allowlist fermée {super},
 * un `status = 'ACTIVE'` et une absence d'expiration.
 *
 * Ne JAMAIS dériver l'autorité de : `profiles.role`, `system_role_id === master`
 * seul, `tenant_id === null`, un tableau frontend, un paramètre d'URL, un rôle
 * stocké localement. La fonction ci-dessous ne prend QUE le signal canonique.
 *
 * Fail-closed : tant que l'autorité n'est pas PROUVÉE (chargement incomplet ou
 * donnée incohérente), on ne monte pas le shell — on charge, puis on refuse.
 */

/** Allowlist FERMÉE des rôles de portail plateforme autorisés à monter le shell. */
export const MASTER_SHELL_ALLOWED_PORTAL_ROLES = Object.freeze(['super']);

/**
 * @param {{ portalRoleId?: string|null, status?: string|null,
 *           expiresAt?: string|number|Date|null, loaded?: boolean,
 *           now?: number }} signal
 * @returns {'loading'|'deny'|'allow'}
 */
export function decideMasterShellAccess(signal = {}) {
  const { portalRoleId, status, expiresAt, loaded, now } = signal;

  // Autorité non encore prouvée : état neutre, on ne monte RIEN.
  if (loaded !== true) return 'loading';

  // Rôle de portail dans l'allowlist fermée — jamais un libellé, jamais NULL.
  if (!MASTER_SHELL_ALLOWED_PORTAL_ROLES.includes(portalRoleId)) return 'deny';

  // Affectation active (ni révoquée, ni inactive).
  if (status !== 'ACTIVE') return 'deny';

  // Non expirée. `now` injectable pour les tests ; sinon horloge courante.
  if (expiresAt != null) {
    const t = expiresAt instanceof Date ? expiresAt.getTime() : new Date(expiresAt).getTime();
    const ref = typeof now === 'number' ? now : Date.now();
    if (!Number.isFinite(t) || t <= ref) return 'deny';
  }

  return 'allow';
}
